import { getDbSupabase } from './supabase';
import { singaporeTodayDateString } from '../utils/dateTime';

const SESSION_KEY_PREFIX = 'bth_reminders_ran_';

export async function refreshMyReminderNotifications(): Promise<boolean> {
  const today = singaporeTodayDateString();
  const sessionKey = `${SESSION_KEY_PREFIX}${today}`;

  try {
    if (sessionStorage.getItem(sessionKey) === '1') {
      return false;
    }
  } catch {
    // ignore
  }

  const { error } = await getDbSupabase().rpc('crm_run_reminder_notifications', {
    p_all_users: false,
  });

  if (error) {
    if (/crm_run_reminder_notifications|42883|does not exist|PGRST202/i.test(error.message ?? '')) {
      return false;
    }
    console.warn('[BTH] reminder notifications failed', error);
    return false;
  }

  try {
    sessionStorage.setItem(sessionKey, '1');
  } catch {
    // ignore
  }

  return true;
}

/** Prefix portal-relative notification links (/tasks, /projects/...). */
export function resolveNotificationLink(link: string, portalBasePath: string): string {
  const trimmed = link.trim();
  if (!trimmed) return trimmed;
  if (trimmed.startsWith('/crm/') || trimmed.startsWith('/it/')) return trimmed;
  if (trimmed.startsWith('/')) {
    const base = portalBasePath.replace(/\/$/, '');
    return `${base}${trimmed}`;
  }
  return trimmed;
}
